import type { PropType } from 'vue';
import type { TSelectOptionProps } from './TSelectOption.types';
import { computed, defineComponent } from 'vue';
import { useStyles } from './TSelectOption.styles';

export const TSelectOption = defineComponent({
  name: 'TSelectOption',
  emits: ['select', 'hover'],
  props: {
    label: String as PropType<TSelectOptionProps['label']>,
    selected: Boolean as PropType<TSelectOptionProps['selected']>,
    highlighted: Boolean as PropType<TSelectOptionProps['highlighted']>,
    disabled: Boolean as PropType<TSelectOptionProps['disabled']>,
    withSeparator: Boolean as PropType<TSelectOptionProps['withSeparator']>,
  },
  setup(props, { slots, emit }) {
    const baseClass = useStyles();
    const classes = computed(() => [
      baseClass.value,
      {
        [`${baseClass.value}--selected`]: props.selected,
        [`${baseClass.value}--highlighted`]: props.highlighted,
        [`${baseClass.value}--disabled`]: props.disabled,
        [`${baseClass.value}--with-separator`]: props.withSeparator,
      },
    ]);

    const handleHover = () => {
      if (!props.disabled) {
        emit('hover');
      }
    };

    const handleMouseDown = (event: MouseEvent) => {
      event.preventDefault();
      if (!props.disabled) {
        emit('select');
      }
    };

    return () => (
      <li
        class={classes.value}
        role="option"
        aria-selected={Boolean(props.selected)}
        onMousedown={handleMouseDown}
        onMouseenter={handleHover}
      >
        {slots.default?.() || props.label}
      </li>
    );
  },
});
